export const RELEASE_DATE_FOR_TIPTAP_EDITOR = '2025-01-29 12:30:00.000000' // TODO: This needs to be updated based on the release date of the new tiptap editor.

export const EVENT_TAB_MODAL = {
  Heading: "Warning",
  Description: "On switching the type of event to 'Free' all the tickets created will be discarded. Continue?",
  Free: "is_free",
  CommunityTicket: "Community Ticket",
  RegularTicket: "Regular Ticket",
  TicketDetails: "ticket_details",
  PrimaryButtonText: "Ok",

};

export const TOOLTIP_CONTENT = {
  CodeExpired: "Code has expired.",
  GroupDescription: "Group Discount Code is auto-applied. Participants are not required to enter.",
  CopyCode: "Copy code",
};

export const CHECKIN_MODES = {
  MANUAL: 2,
  SILENT: 1,
};
export const PRINT_MODES = {
  MANUAL_PRINTING: 2,
  SILENT_PRINTING: 1,
};
export const PRINT_TYPE = {
  SINGLE_SIDED_PRINTING: 1,
  DOUBLE_SIDED_PRINTING: 2,
};

export const TABLE_CELLS_NAMES = {
  MANUAL: "Manual",
  SILENT: "Silent",
  ENABLED: "ENABLED",
  DISABLED: "DISABLED",
}
export const SCREENS = {
  EDIT_CHECK_IN: "EditCheckIn",
  ADD_CHECK_IN: "AddCheckIn",
};

export const REUSABLE_SCREENS = {
  showListOfItems: "showListOfItems",
  addScreen: "addScreen",
  editScreen: "editScreen"
}

export const DAYS_ARR = [
  {
    value: "7",
    label: "Last 7 days"
  },
  {
    value: "30",
    label: "Last 30 days"
  },
  {
    value: "90",
    label: "Last 90 days"
  }, {
    value: "custom",
    label: "Custom"
  }
]

export const COMPONENTS = {
  SETTLEMENTS: "settlements",
}

export const threeDecimalCurrencies = ["KWD", "JOD", "OMR", "TND", "BHD"];

export const zeroDecimalCurrencies = [
  "BIF", "CLP", "DJF", "GNF", "JPY", "KMF", "KRW", "MGA",
  "PYG", "RWF", "UGX", "VND", "VUV", "XAF", "XOF", "XPF"
];
